// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".productTag{color:#575766;display:inline-block;font-size:1.2rem;line-height:2rem;text-transform:capitalize}.productTag__text{display:inline-flex;font-family:\"Rubik\",serif;font-weight:500;text-transform:none}.productTag__color{align-items:center;border-radius:50%;display:inline-flex;height:1rem;justify-content:center;margin-right:2px;position:relative;top:-1px;width:1rem}.productTag__colorCircle{border-radius:50%;display:block;height:.6rem;width:.6rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
